// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".footnote-text[data-v-584f7b14]{color:var(--color-gray-80);font-size:10px;line-height:1.2;overflow-wrap:break-word}.footnote-text a[data-v-584f7b14]{text-decoration:underline}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
